import React, { Suspense, useRef } from 'react'
import gsap from 'gsap'
import { Root, Container, Text, Image } from '@react-three/uikit'
import { Twitter, Github, Linkedin, Instagram, Youtube, Facebook, Mail, Globe, Music } from '@react-three/uikit-lucide'
import { useWebCrafter } from '@webcrafter/common'

// Placeholder profile image (using a generic avatar or you can use a local asset)
const PROFILE_IMG = "https://avatars.githubusercontent.com/u/61922101?v=4"

const SOCIAL_ICONS_MAP = {
    twitter: Twitter,
    instagram: Instagram,
    github: Github,
    linkedin: Linkedin,
    youtube: Youtube,
    facebook: Facebook,
    tiktok: Music,
    email: Mail,
    web: Globe
}

export function LinkBioUI()
{
    const { siteData: config, siteData: rawSiteData } = useWebCrafter()




    return (
        <Root>
            <Container
                flexDirection="column"
                alignItems="center"
                backgroundColor="white"
                borderRadius={32}
                padding={32}
                gap={16}
                width={400}
                borderColor="#ccc"
                borderWidth={2}
                opacity={0.95}
            >
                {/* Profile Image */}
                <Suspense fallback={null}>
                    <ProfileImage src={config?.profileImage || PROFILE_IMG} />
                </Suspense>

                {/* Name */}
                <Text fontSize={24} fontWeight="bold" color="black">
                    {config?.profileName || "Your Name"}
                </Text>

                {/* Bio */}
                <Text fontSize={16} color="black" textAlign="center">
                    {config?.profileBio || "Digital Creator & 3D Artist. Creating immersive web experiences."}
                </Text>

                {/* Links */}
                <Container flexDirection="column" gap={12} width="100%">
                    {(config?.myLinks || []).map((link, i) => (
                        <LinkButton key={i} text={link.title} url={link.url} target="_blank" />
                    ))}
                </Container>

                {/* Socials */}
                <Container flexDirection="row" gap={16} marginTop={16}>
                    {(config?.mySocials || []).map((item, i) =>
                    {
                        const Icon = SOCIAL_ICONS_MAP[ item.network ] || Globe
                        return <SocialButton key={i} icon={Icon} url={item.url} target="_blank" />
                    })}
                </Container>
            </Container>
        </Root>
    )
}

function ProfileImage({ src })
{
    return (
        <Image
            src={src}
            width={96}
            height={96}
            borderRadius={48}
            keepAspectRatio
        />
    )
}

function LinkButton({ text, url, target })
{
    const ref = useRef()

    return (
        <Container
            ref={ref}
            backgroundColor="#f0f0f0"
            borderRadius={16}
            padding={16}
            width="100%"
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
            onClick={() => window.open(url, target || '_blank')}
            hover={{ transformTranslateZ: 20, backgroundColor: "#c0c0c0" }}
            onPointerEnter={(e) =>
            {
                e.stopPropagation()
                if (ref.current)
                {
                    gsap.to(ref.current.scale, {
                        x: 1.05,
                        y: 1.05,
                        z: 1.05,
                        duration: 0.3,
                        ease: 'back.out(2)'
                    })
                }
            }}
            onPointerLeave={(e) =>
            {
                e.stopPropagation()
                if (ref.current)
                {
                    gsap.to(ref.current.scale, {
                        x: 1,
                        y: 1,
                        z: 1,
                        duration: 0.3,
                        ease: 'power2.out'
                    })
                }
            }}
            onPointerDown={(e) =>
            {
                e.stopPropagation()
                if (ref.current)
                {
                    gsap.to(ref.current.scale, { x: 0.95, y: 0.95, z: 0.95, duration: 0.1 })
                }
            }}
            onPointerUp={(e) =>
            {
                e.stopPropagation()
                if (ref.current)
                {
                    gsap.to(ref.current.scale, { x: 1.05, y: 1.05, z: 1.05, duration: 0.1 })
                }
            }}
        >
            <Text fontSize={16} fontWeight="medium" color="black">{text}</Text>
        </Container>
    )
}

function SocialButton({ icon: Icon, url, target })
{
    const ref = useRef()

    return (
        <Container
            ref={ref}
            cursor="pointer"
            onClick={() => window.open(url, target || '_blank')}
            padding={8}
            borderRadius={12}
            hover={{ transformTranslateZ: 4 }}

        >
            <Icon width={24} height={24} color="black" />
        </Container>
    )
}
